import * as apiLib from './api';

export const list = async payload => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/facility/list', data);
    if (result.resultFlag) {
      return result.facilityList;
    } else {
      throw Object.assign(new Error('facility list error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const detail = async payload => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/facility/detail', data);
    if (result.resultFlag) {
      return result.facilityInfo;
    } else {
      throw Object.assign(new Error('facility detail error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const add = async payload => {
  try {
    const data = { ...payload };
    const result = await apiLib.fetchArchiveApi('/facility/add', data);
    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('facility add error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const edit = async payload => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/facility/edit', data);
    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('facility edit error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const remove = async payload => {
  try {
    const data = { ...payload };

    const result = await apiLib.fetchArchiveApi('/facility/remove', data);
    if (result.resultFlag) {
      return true;
    } else {
      throw Object.assign(new Error('facility remove error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};
